"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _excluded = ["unique"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var propTypes = {
  unique: _propTypes.string
};

var TriangleUp = function TriangleUp(_ref) {
  var _ref$unique = _ref.unique,
      unique = _ref$unique === void 0 ? "" : _ref$unique,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("defs", {
    fill: "inherit"
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "inherit",
    fillRule: "evenodd",
    id: "glyphs/nav/triangle_up-triangle-up" + unique,
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/_react["default"].createElement("use", {
    fill: "inherit",
    id: "triangle-triangle-up" + unique,
    xlinkHref: "#path-1-triangle-up" + unique
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "inherit",
    id: "colors/core/gunmetal-triangle-up" + unique
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.3951099,6.19361172 L20.8746195,17.1277161 C21.043846,17.3459293 21.0041345,17.6600113 20.7859213,17.8292378 C20.6982499,17.8972279 20.5904552,17.9341279 20.4795096,17.9341279 L3.52049045,17.9341279 C3.24434807,17.9341279 3.02049045,17.7102703 3.02049045,17.4341279 C3.02049045,17.3231823 3.05739044,17.2153876 3.12538055,17.1277161 L11.6048901,6.19361172 C11.7741166,5.97539855 12.0881986,5.93568704 12.3064118,6.10491358 C12.339584,6.13063899 12.3693845,6.16043949 12.3951099,6.19361172 Z",
    fill: "inherit",
    id: "path-1-triangle-up" + unique
  }))));
};

TriangleUp.propTypes = propTypes;
var _default = TriangleUp;
exports["default"] = _default;